// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ht-z","tooltipWrapper":"It-z","icon":"Jt-z","tooltip":"Kt-z","content":"Lt-z"};